var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint0_linear_3148_7056)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3148_7056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3148_7056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 16.7625L14.1626 15.925L14.8751 15.2125H12.9126V14.0375H14.8751L14.1626 13.325L15.0001 12.4875L17.1376 14.625L15.0001 16.7625ZM6.9126 17.0125V7.78748H15.7126V11.5875C15.5987 11.5514 15.4806 11.5278 15.3585 11.5166C15.2362 11.5055 15.1157 11.5 14.997 11.5C14.9199 11.5 14.8428 11.5049 14.7657 11.5146C14.6886 11.5243 14.6126 11.5402 14.5376 11.5625V8.96248H8.0876V14.0375H12.0626C12.0403 14.1125 12.0244 14.1885 12.0147 14.2656C12.005 14.3427 12.0001 14.4198 12.0001 14.4969C12.0001 14.6156 12.0056 14.7361 12.0167 14.8584C12.0279 14.9805 12.0515 15.0986 12.0876 15.2125H8.7126L6.9126 17.0125ZM9.0251 10.925H13.6126V9.89998H9.0251V10.925ZM9.0251 12.975H12.1126V11.95H9.0251V12.975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3148_7056",
    x1: 1.89685,
    y1: 1.72103,
    x2: 21.1666,
    y2: 21.4607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF574D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestNew);
export default __webpack_public_path__ + "static/media/request_new.c1ae788ab29013ef75a04c4408f9b429.svg";
export { ForwardRef as ReactComponent };